import Icon from '../components/Icon.vue'

Icon.register({"arrow-circle-left":{"width":512,"height":512,"paths":[{"d":"M256 504C119 504 8 393 8 256S119 8 256 8 504 119 504 256 393 504 256 504zM284.9 360.4L209.4 288H392C405.3 288 416 277.3 416 264V248C416 234.7 405.3 224 392 224H209.4L284.9 151.6C294.6 142.3 294.8 126.8 285.3 117.3L274.3 106.4C264.9 97 249.7 97 240.4 106.4L107.7 239C98.3 248.4 98.3 263.6 107.7 272.9L240.4 405.6C249.8 415 265 415 274.3 405.6L285.3 394.7C294.8 385.2 294.6 369.7 284.9 360.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-circle-left.js
// module id = TZ9d
// module chunks = 0